/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SpendRuleEvent,
  SpendRuleEvent$inboundSchema,
} from "./spendruleevent.js";

export type ListSpendRuleEventsResult = {
  /**
   * The list of budget rule events, most recent first.
   */
  events: Array<SpendRuleEvent>;
  /**
   * Cursor for the next page of events.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListSpendRuleEventsResult$inboundSchema: z.ZodMiniType<
  ListSpendRuleEventsResult,
  unknown
> = z.pipe(
  z.object({
    events: z.array(SpendRuleEvent$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listSpendRuleEventsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSpendRuleEventsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSpendRuleEventsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSpendRuleEventsResult' from JSON`,
  );
}
